const foreignWorkerView = (data) => {
  let formData =
    data &&
    data.getForeignWorkerById &&
    data.getForeignWorkerById.ForeignWorkerFormData;
  if (formData) {
    let view = {
      name: formData.new_profile_fw_profile_name,
      sections: [
        {
          name: "Foreign Worker Information",
          fields: [
            {
              number: 1,
              label: "Foreign Worker's Last ( family) Name",
              value: formData.new_profile_fw_last,
            },
            {
              number: 2,
              label: "Foreign Worker's First (given) Name",
              value: formData.new_profile_fw_first,
            },
            {
              number: 3,
              label: "Foreign Worker's First (given) Name",
              value: formData.new_profile_fw_middle,
            },
            {
              number: 4,
              label: "A.4. Address 1 (current)",
              value: formData.new_profile_fw_address,
            },
            {
              number: 5,
              label: "City",
              value: formData.new_profile_fw_city,
            },
            {
              number: 6,
              label: "State",
              value: formData.new_profile_fw_state,
            },
            {
              number: 7,
              label: "Postal Code",
              value: formData.new_profile_fw_postal_code,
            },
            {
              number: 8,
              label: "Country",
              value: formData.new_profile_fw_country,
            },
            {
              number: 9,
              label: "Province",
              value: formData.new_profile_fw_province,
            },
            {
              number: 10,
              label: "Date of Birth (mm/dd/yyyy)",
              value: formData.new_profile_fw_dob,
            },
            {
              number: 11,
              label: "Class of Admission",
              value: formData.new_profile_fw_class,
            },
            {
              number: 12,
              label: "Alien Registration Number (A#) (if applicable)",
              value: formData.new_profile_fw_alien_reg_number,
            },
            {
              number: 13,
              label: "Country of Birth",
              value: formData.new_profile_fw_birth_country,
            },
            {
              number: 14,
              label: "Country of Citizenship or Nationality",
              value: formData.new_profile_fw_citizen_country,
            },
          ],
        },
      ],
    };
    return view;
  }
};

export default foreignWorkerView;
